
import React from 'react'
import ClanConnectLogo from '../../assets/images/clan_connect_logo.png';
import { NavLink } from 'react-router-dom';

interface Props {
    isLogin: any;
    user:any;
    location:any;
    HeaderMenu: any;
    getDashboardLink:any;
}

function HeaderLeft({ isLogin, user, location, HeaderMenu, getDashboardLink }: Props) {

  const agencyUrls = [
    '/agency/settings/personal-info',
    '/agency/settings/companydetails',
    '/agency/settings/security',
    '/agency/settings/subscription',
    '/agency/settings/subscription-history',
    '/agency/settings/notifications',
    '/brand/admin-dashboard/influencer-signups',
    '/brand/admin-dashboard'
  ];
  const talentPartnerUrls = [
    '/talent-partner/settings/personal-info',
    '/talent-partner/settings/companydetails',
    '/talent-partner/settings/brand-list',
    '/talent-partner/settings/security',
    '/talent-partner/settings/subscription',
    '/talent-partner/settings/subscription-history',
    '/talent-partner/settings/notifications'
  ];

  const showAdminDashboard =
    user?.account_type === "Agency" &&
    user?.view_admin_dashboard === "True" &&
    (
      agencyUrls.some(url => location.pathname.startsWith(url)) ||
      location.pathname === "/switch/user"
    );

const hiddenUrls = [
  '/switch/account',
  '/switch/user',
  ...agencyUrls,
  ...talentPartnerUrls,
];

const shouldHideMenu = hiddenUrls.includes(location.pathname);

  return (
    <div
    className={`app-header_brand_left_side ${user?.account_type === 'Influencer' && " d-none d-md-flex"}` }
    >

      <NavLink className="logo" to={getDashboardLink()}>
        <img src={ClanConnectLogo} alt="Clan Connect" />
      </NavLink>

      {isLogin && !shouldHideMenu && (
        <nav className="nav-menu">
          <ul className="app_header_ul d-none d-lg-flex">

            {showAdminDashboard ? (
              <li>
                <NavLink className="header_links" to="/brand/admin-dashboard">
                  Admin Dashboard
                </NavLink>
              </li>
            ) : (
              HeaderMenu.map((menu: any) => (
                <li key={menu.id}>
                  <NavLink className="header_links" to={menu.url}>
                    {menu.title}
                  </NavLink>
                </li>
              ))
            )}

          </ul>
        </nav>
      )}

    </div>
  );
}


export default HeaderLeft
